const authorPersonSchemas: Record<string, any> = {
  'alex-saiz': {
    '@context': 'https://schema.org',
    '@type': 'Person',
    name: 'Alex Saiz Verdaguer',
    jobTitle: 'CEO & Co-founder',
    worksFor: {'@id': 'https://monei.com/#organization'},
    alumniOf: 'Stanford University',
    nationality: 'ES',
    image:
      'https://images.prismic.io/monei/ZkHah0FLKBtrWzuz_ce1c4cc9-b854-4dc3-8383-e56b4ec6e95b_Alex_Saiz-1-.jpg',
    sameAs: [
      'https://www.linkedin.com/in/alexandresaiz/',
      'https://www.wikidata.org/wiki/Q139678380',
      'https://www.crunchbase.com/person/alexandre-saiz'
    ]
  },
  'alexis-damen': {
    '@context': 'https://schema.org',
    '@type': 'Person',
    name: 'Alexis Damen',
    jobTitle: 'Content Marketing',
    worksFor: {'@id': 'https://monei.com/#organization'},
    alumniOf: 'Fashion Institute of Technology',
    nationality: 'US',
    image: 'https://images.prismic.io/monei/ZkHSGUFLKBtrWzpW_alexis-damen.jpg?auto=format,compress',
    sameAs: [
      'https://www.linkedin.com/in/alexis-mera-damen/',
      'https://alexisdamen.com/',
      'https://www.meramagazine.com/'
    ]
  }
};

export const getAuthorPersonSchema = (uid: string, language: string): any | undefined => {
  const person = authorPersonSchemas[uid];
  if (!person) return undefined;

  const url = `https://monei.com/${language === 'es' ? 'es/' : ''}author/${uid}/`;
  return {...person, '@id': url, url};
};
